/* 商品页结账入口文案
 * Shopify 的 accelerated-checkout 组件共有两种渲染结果：
 *
 *   A. 钱包可用（US / DE / GB 等 PayPal 服务国）
 *      注入 <a id="more-payment-options-link">More payment options</a>
 *   B. 钱包不可用（未覆盖的地区、脚本超时、网络受限）
 *      注入 <button class="shopify-payment-button__button--unbranded">Buy it now</button>
 *
 * 两种文案都打包在 portable-wallets.en.js 内部，主题的 Liquid / 语言文件改不到，
 * 只能在运行时替换文字节点。点击行为绑在组件自身，替换 textContent 不影响跳转。
 *
 * 统一改成 "Check out Now"，这样无论命中哪条分支，用户看到的名字都一样。
 * 按钮外观由 snippets/buy-buttons.liquid 末尾的 <style> 负责，不依赖本脚本；
 * 即使脚本未执行，两个入口本身仍然可点。
 */
(function () {
  if (window.__lhCheckoutLabel) return;
  window.__lhCheckoutLabel = true;

  var LABEL = 'Check out Now';
  var SEL = '#more-payment-options-link';
  var FB = '.shopify-payment-button__button--unbranded';

  function setText(el) {
    if (el.textContent.trim() !== LABEL) el.textContent = LABEL;
  }

  function patch() {
    var nodes = document.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) setText(nodes[i]);

    // 仅在「更多支付选项」缺席时处理回落按钮，避免两个入口同时改名造成误解
    if (!nodes.length) {
      var fbs = document.querySelectorAll(FB);
      for (var j = 0; j < fbs.length; j++) setText(fbs[j]);
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    var run = function () { scheduled = false; patch(); };
    if (window.requestAnimationFrame) window.requestAnimationFrame(run);
    else setTimeout(run, 16);
  }

  function start() {
    patch();
    if (!document.body || typeof MutationObserver === 'undefined') return;
    // 组件异步渲染，且切换变体时可能重建节点，所以持续观察
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
